import 'whatwg-fetch'
import * as commonScripts from '../common'
import utils from '../common/util'
import { listContainer } from './partials/fund-list/fund-list-container'
import { initSearchFund } from './partials/fund-list/fundSearch'
import cmpSelectChoices from './cmp-select-choices'
import MicroModal from 'micromodal'

// variable needed for destroy and create new instance
var documentsChoicesInstance = null
var performancesChoicesInstance = null

const cmpFundListNonUs = {
	component: null,
	accordionContainer: null,
	documentsContainer: null,
	documentsSelector: null,
	performancesSelector: null,
	performancesContainer: null,
	performances: null,
	brexitCookieValue: 'UkUcits',
	init: async function (element) {
		const _ = this
		_.component = element

		commonScripts.util.animationTranslate(this)
		_.accordionContainer = _.component.querySelector(
			'.cmp-fund-list-non-us__accordion'
		)
		_.documentsContainer = _.component.querySelector(
			'.cmp-fund-list-non-us__documents__list '
		)
		_.documentsSelector = _.component.querySelector(
			'.cmp-fund-list-non-us__documents__fund-type-selector'
		)
		_.performancesContainer = _.component.querySelector(
			'.cmp-fund-list-non-us__performances__list '
		)
		_.performancesSelector = _.component.querySelector(
			'.cmp-fund-list-non-us__performances__fund-type-selector'
		)
		_.onPageLoad(_.component)
		_.populateFunds()

		// Fund selector on change handler.
		const fundSelector = _.component.querySelector(
			'.cmp-fund-list-non-us__fund-selector'
		)

		if(_.documentsSelector != null)	
		documentsChoicesInstance = cmpSelectChoices.init(_.documentsSelector)

		if(_.performancesSelector != null)
		performancesChoicesInstance = cmpSelectChoices.init(_.performancesSelector)

		fundSelector.addEventListener('change', async (event) => {
			_.populateFunds()

			const searchParams = new URLSearchParams()

			searchParams.set('assetClassId', fundSelector.value)

			const url =
				window.location.origin +
				window.location.pathname +
				'?' +
				searchParams.toString()
			window.history.replaceState({}, document.title, url)
		})

		initSearchFund(_.component)

		if (_.performancesSelector != null) {
			_.performancesSelector.addEventListener('change', async (event) => {
				const id = _.performancesSelector.value
				let language = document.documentElement.lang
				if (language.length === 0) {
					language = 'en'
				}

				window.fetch("/api/get-fund-performance-korea-list?id=" + id + '&lang=' + language)
					.then((response) => {
						if (!response.ok) {
							throw new Error('Network response was not ok')
						}
						return response.json()
					}).then((body) => {
						performanceContainerTemplate(body, _.performancesContainer)
					}).catch((err) => {
						console.log('Request Failed', err)
					})
			})
		}
	},

	onPageLoad: function (component) {
		const fundSelector = component.querySelector(
			'.cmp-fund-list-non-us__fund-selector'
		)
		if (window.location.search) {
			const searchParams = new URLSearchParams(window.location.search)
			const fundId = searchParams.get('assetClassId')
			const choicesFundSelector = cmpSelectChoices.init(fundSelector)

			if (choicesFundSelector) {
				choicesFundSelector.setChoiceByValue(fundId)
			}
		} else {
			const url =
				window.location.origin +
				window.location.pathname +
				'?' +
				'assetClassId=' +
				fundSelector.value
			window.history.replaceState({}, document.title, url)
			cmpSelectChoices.init(fundSelector)
		}
	},

	populateFunds: async function () {
		const _ = this
		utils.isLoading(true)
		const fundsNonUs = await _.getFundData()
		//console.log(fundsNonUs)
		_.accordionContainer.innerHTML = ''
		_.documentsContainer.innerHTML = ''
		_.documentsSelector.innerHTML = ''
		if (_.performancesContainer != null)
			_.performancesContainer.innerHTML = ''
		if (_.performancesSelector != null)
			_.performancesSelector.innerHTML = ''
		_.component.querySelector('.list').innerHTML = ''

		_.showBrexitModal(fundsNonUs.hasBrexitFunds)
		let language = document.documentElement.lang
		if (language.length === 0) {
			language = 'en'
		}

		listContainer(fundsNonUs.fundList.funds, language)

		populateShareClassesTab(fundsNonUs, _.accordionContainer)

		fillSelectForDocuments(_.documentsSelector, fundsNonUs)
		populateFirstDocuments(_.documentsContainer, fundsNonUs)
		documentsSelectOnChangeHandler(
			_.documentsSelector,
			fundsNonUs,
			_.documentsContainer
		)

		fillSelectForPerformances(_.performancesSelector, fundsNonUs)
		populateFirstPerformances(_.performancesSelector, _.performancesContainer, fundsNonUs)

		initAccordion(_.component)
		utils.isLoading(false)
	},
	getFundData: async function () {
		const _ = this
		const id = document.getElementById('list-page-id').value
		let language = document.documentElement.lang
		if (language.length === 0) {
			language = 'en'
		}

		const selection = document.querySelector(
			'.cmp-fund-list-non-us__fund-selector'
		).value
		let apiURL = ''
		if (window.location.hostname !== 'localhost') {
			apiURL = '/api/fundshareclasslist/'
		}

		const url =
			apiURL +
			id +
			'?s=' +
			selection +
			'&lang=' +
			language +
			'&isUkUcitsInvestor=' +
			_.getUkUcitsFromCookie()

		const response = await window.fetch(url)
		const data = await response.json()
		return data.JsonContent
	},
	getUkUcitsFromCookie: function () {
		const _ = this
		const cookie = utils.cookies.get('fundAccept')
		const regionInvestorType = this.getRegionFromModal() + this.getInvestorTypeFromModal()
		if (cookie != null && cookie.indexOf(_.brexitCookieValue) > -1 && cookie.indexOf(regionInvestorType) > -1) {
			return true
		} else {
			return false
		}
	},
	setUkUcitsCookie: function () {
		const _ = this
		let cookie = utils.cookies.get('fundAccept')
		_.brexitCookieValue += this.getRegionFromModal()
		_.brexitCookieValue += this.getInvestorTypeFromModal()
		if (cookie != null && cookie.indexOf(_.brexitCookieValue === -1)) {
			cookie += _.brexitCookieValue
		} else {
			cookie = _.brexitCookieValue
		}

		utils.cookies.set('fundAccept', cookie, '/', 1)
	},
	getRegionFromModal: function () {
		const _ = this
		const region = document.querySelector('#fundsBrexitModal-region')
		if (region != null) {
			return '-' + region.value
		} else {
			return ""
		}
	},
	getInvestorTypeFromModal: function () {
		const _ = this
		const investorType = document.querySelector('#fundsBrexitModal-investorType')
		if (investorType != null) {
			return '-' + investorType.value + '|'
		} else {
			return "|"
		}
	},
	showBrexitModal: function (show) {
		const _ = this
		const brexitModal = document.querySelector('#brexitModal')
		if (brexitModal != null && show && !_.getUkUcitsFromCookie()) {
			brexitModal.style.display = 'block'

			// bind modal functionality
			MicroModal.init({
				openTrigger: 'data-custom-open',
				closeTrigger: 'data-custom-close',
				openClass: 'is-open',
				disableScroll: true,
				disableFocus: false,
				awaitOpenAnimation: false,
				awaitCloseAnimation: false,
				debugMode: false
			})

			const button = document.querySelector('#btnBrexitModal')
			if (button != null) {
				button.addEventListener('click', (event) => {
					MicroModal.show('fundsBrexitModal', {})
				})
			}

			const confirm = document.querySelector('#fundsBrexitModal-accept')
			if (confirm != null) {
				confirm.addEventListener('click', async (event) => {
					_.setUkUcitsCookie()
					documentsChoicesInstance.destroy()
					documentsChoicesInstance = null
					_.populateFunds()
					brexitModal.style.display = 'none'
					MicroModal.close('fundsBrexitModal')
				})
			}
		}
	},
}

async function getFundPefromanceKoreaData(id) {
	let language = document.documentElement.lang
	if (language.length === 0) {
		language = 'en'
	}
	const response = await window.fetch("/api/get-fund-performance-korea-list?id=" + id + '&lang=' + language)
	const data = await response.json()
	return data
}

function initAccordion(component) {
	const _ = this
	component
		.querySelectorAll('.cmp-fund-list-non-us__accordion__option__toggle')
		.forEach((accordionButton, index) => {
			accordionButton.addEventListener(
				'click',
				function (event) {
					const optionContent = event.target.parentElement
					optionContent.classList.toggle('show-option')
					let table = optionContent.querySelector('table')
					//console.log(table)
					if (table.childElementCount == 0) {
						let fundId = optionContent.dataset.fundId
						let investorTypeId = optionContent.dataset.investorTypeId
						if (optionContent.classList.contains('show-option')) {
							getShareClassTableData(fundId, investorTypeId, 1, table)
						}
					}
				},
				false
			)
		})
}

function populateShareClassTable(tableData, table) {
	let id = tableData.JsonContent.fundId
	//let table = document.querySelector('#fund-' + id + ' table')
	let tbody = createShareClassTableBody(tableData)
	table.appendChild(tbody)
}

function getShareClassTableData(fundId, investorType, page, table) {
	const _ = this
	const rowsPerPage = 24
	let language = document.documentElement.lang
	if (language.length == 0) {
		language = 'en'
	}

	const fetchOpts = {
		method: 'GET',
		headers: {}
	}
	let apiURL
	if (window.location.hostname !== 'localhost') {
		apiURL = '/api/fundshareclasstable/'
	}

	let showKiids = document.getElementById('show-kiids').value
	if (!showKiids) {
		showKiids = 'false'
	}

	let url =
		apiURL +
		fundId +
		'?i=' +
		investorType +
		'&lang=' +
		language +
		'&p=' +
		page +
		'&k=' +
		showKiids

	const loadingDiv = utils.createLoadingElement()
	table.appendChild(loadingDiv)

	window
		.fetch(url, fetchOpts)
		.then((response) => {
			if (!response.ok) {
				throw new Error('Network response was not ok')
			}
			return response.json()
		})
		.then((data) => {
			loadingDiv.remove()
			//console.log(data)
			createShareClassTableHeader(data.JsonContent.tableHead, table)
			populateShareClassTable(data, table)

			var loadMoreBtn
			if (data.JsonContent.totalCount > page * rowsPerPage) {
				loadMoreBtn = utils.createLoadMoreButton()
				table.after(loadMoreBtn)
				loadMoreBtn.addEventListener('click', function (e) {
					loadMoreBtn.remove()
					getShareClassTableData(fundId, investorType, (page + 1), table)
				})
			} else {
				if (loadMoreBtn) {
					loadMoreBtn.remove()
				}
			}
		})
		.catch((err) => {
			console.log('Request Failed', err)
		})

}

function populateShareClassesTab(fundsNonUs, accordionContainer) {
	fundsNonUs.funds.forEach((shareClass) => {
		const newDiv = document.createElement('div')
		newDiv.innerHTML = shareClassContainerTemplate(shareClass)
		accordionContainer.appendChild(newDiv)
	})
}
function populateFirstDocuments(documentsContainer, fundsNonUs) {
	documentsContainer.innerHTML = ''
	const newDiv = document.createElement('div')
	newDiv.classList.add(
		'cmp-fund-list-non-us__documents__list__item',
		'col-12',
		'col-sm-10',
		'offset-sm-1'
	)

	let searchParams
	if (window.location.search) {
		searchParams = new URLSearchParams(window.location.search)
	}

	// if (searchParams && searchParams.get('documentId')) {
	// 	newDiv.innerHTML = documentTemplate(
	// 		fundsNonUs.fundDocuments[searchParams.get('documentId')]
	// 	)
	// } else {
	// 	newDiv.innerHTML = documentTemplate(fundsNonUs.fundDocuments[0])
	// }
	newDiv.innerHTML = documentTemplate(fundsNonUs.fundDocuments[0])

	documentsContainer.appendChild(newDiv)
}

function fillSelectForDocuments(documentsSelector, fundsNonUs) {
	let optionsList = []
	fundsNonUs.funds.forEach((fundItem, index) => {
		let dropDownData = {}
		if(index == 0)
			dropDownData = {value: fundItem.fundId, label: fundItem.fundName, selected: true}
		else
			dropDownData = {value: fundItem.fundId, label: fundItem.fundName}
		optionsList.push(dropDownData)
	})

	let searchParams
	if (window.location.search) {
		searchParams = new URLSearchParams(window.location.search)
	}


	if (searchParams && searchParams.get('documentId')) {
		documentsChoicesInstance.clearStore();
		documentsChoicesInstance.setChoices(optionsList, 'value', 'label', false)
		documentsChoicesInstance.setChoiceByValue(searchParams.get('documentId'))
	} else {
		documentsChoicesInstance.clearStore();
		documentsChoicesInstance.setChoices(optionsList, 'value', 'label', false)
	}
}

function documentsSelectOnChangeHandler(
	documentsSelector,
	fundsNonUs,
	documentsContainer
) {
	documentsSelector.addEventListener('change', async (event) => {
		//const option = fundsNonUs.fundDocuments[event.target.value]
		let option = fundsNonUs.fundDocuments.find(x => x.fundId == event.target.value)

		if(option == undefined){
			var fundDocData = await getFundDocuments(event.target.value);
			if(fundDocData != undefined){
				fundsNonUs.fundDocuments.push(fundDocData)
				option = fundDocData
			}
		}
		
		const newDiv = document.createElement('div')
		newDiv.classList.add(
			'cmp-fund-list-non-us__documents__list__item',
			'col-12',
			'col-sm-10',
			'offset-sm-1'
		)
		newDiv.innerHTML = documentTemplate(option)
		const newDivContainer = document.createElement('div')
		newDivContainer.appendChild(newDiv)
		documentsContainer.innerHTML = newDivContainer.innerHTML

		let searchParams

		if (window.location.search) {
			searchParams = new URLSearchParams(window.location.search)
			searchParams.set('documentId', event.target.value)
		}

		const url =
			window.location.origin +
			window.location.pathname +
			'?' +
			searchParams.toString()
		window.history.replaceState({}, document.title, url)
	})
}

async function populateFirstPerformances(performancesSelector, performancesContainer, fundsNonUs) {
	if (performancesSelector != null && performancesContainer != null) {
		const id = performancesSelector.value
		var data = await getFundPefromanceKoreaData(id)
		performanceContainerTemplate(data, performancesContainer)
	}
}

function fillSelectForPerformances(performancesSelector, fundsNonUs) {
	let optionsList = []
	fundsNonUs.funds.forEach((fundPerformance, index) => {
		let dropDownData = {}
		if(index == 0)
			dropDownData = {value: fundPerformance.fundId, label: fundPerformance.fundName, selected: true}
		else
			dropDownData = {value: fundPerformance.fundId, label: fundPerformance.fundName}
		
		if(performancesSelector != null)
		optionsList.push(dropDownData)
	})


	if(performancesSelector != null){
		performancesChoicesInstance.clearStore();
		performancesChoicesInstance.setChoices(optionsList, 'value', 'label', false)
	}
}

function createShareClassTable(shareClassTable) {
	if (!shareClassTable) return ''
	//const table = document.createElement('table')
	const thead = document.createElement('thead')
	const tbody = document.createElement('tbody')
	// First child of table data are table headers
	shareClassTable[0].item.forEach((tableHeader) => {
		const th = document.createElement('th')
		th.innerHTML = tableHeader.rowData
		thead.appendChild(th)
	})

	// Start index at 1.
	for (let index = 1; index < shareClassTable.length; index++) {
		const tr = document.createElement('tr')
		const rows = shareClassTable[index].item

		rows.forEach((row) => {
			const td = document.createElement('td')
			if (row.isLink) {
				td.innerHTML = `<a href="${row.url}" class="cta-link text-green-400">${row.rowData}</a>`
			} else if (row.isKiid) {
				if (row.url.length > 0) {
					td.innerHTML = `<a href="${row.url}" class="cta-link text-green-400"><span
          class="icon icon--download-no-circle"></span></a>`
				} else {
					td.innerHTML = ''
				}
			} else if (row.isHistoric) {
				td.innerHTML = `<a href="${row.url}" class="cta-link text-green-400"><span
        class="icon icon--presentation"></span></a>`
			} else {
				td.innerHTML = row.rowData
			}

			tr.appendChild(td)
		})
		tbody.appendChild(tr)
	}
	table.appendChild(thead)
	table.appendChild(tbody)

	return table.innerHTML
}

function createShareClassTableBody(shareClassTable) {
	if (!shareClassTable) return ''
	const tbody = document.createElement('tbody')

	shareClassTable.JsonContent.tableRows.forEach((row) => {
		const tr = document.createElement('tr')
		row.item.forEach((column) => {
			const td = document.createElement('td')
			if (column.isLink) {
				td.innerHTML = `<a href="${column.url}" class="cta-link text-green-400">${column.rowData}</a>`
			} else if (column.isKiid) {
				if (column.url.length > 0) {
					td.innerHTML = `<a href="${column.url}" class="cta-link text-green-400"><span
          class="icon icon--download-no-circle"></span></a>`
				} else {
					td.innerHTML = ''
				}
			} else if (column.isHistoric) {
				td.innerHTML = `<a href="${column.url}" class="cta-link text-green-400"><span
        class="icon icon--presentation"></span></a>`
			} else {
				td.innerHTML = column.rowData
			}
			tr.appendChild(td)
		})
		tbody.appendChild(tr)
	})

	return tbody
}

function createShareClassTableHeader(shareClassTable, tableData) {
	if (!shareClassTable) return ''
	let table
	if (tableData == undefined || tableData == null) {
		table = document.createElement('table')
	}
	else {
		table = tableData
	}
	const thead = document.createElement('thead')
	const tbody = document.createElement('tbody')
	// First child of table data are table headers
	if (shareClassTable.Count != undefined) {
		shareClassTable = shareClassTable[0]
	}
	shareClassTable.item.forEach((tableHeader) => {
		const th = document.createElement('th')
		th.innerHTML = tableHeader.rowData
		thead.appendChild(th)
	})
	table.appendChild(thead)
	return table.innerHTML
}

function createLinksForDocuments(documents) {
	let linksContainer = ''

	documents.forEach((document) => {
		const linkHtml = `<div class="cmp-fund-list-non-us__documents__list__item__links__link">
    <a href="${document.url}" target='_blank' class="cta-link text-green-400">${document.name}</a>
</div>`
		linksContainer += linkHtml
	})

	return linksContainer
}

function documentTemplate(fundDocument) {
	let template = ''
	if (fundDocument == null) {
		return
	}
	fundDocument.fundDocumentGroups.forEach((documentGroup) => {
		const documentContainer = `
            <div class="cmp-fund-list-non-us__documents__list__item__headline">
                ${documentGroup.categoryName}
            </div>
            <div class="cmp-fund-list-non-us__documents__list__item__links">
            ${createLinksForDocuments(documentGroup.documents)}
             
            </div>
            <div class="cmp-fund-list-non-us__documents__list__item__disclaimer">
            ${documentGroup.disclaimer ? documentGroup.disclaimer : ''}
            </div>
  `
		template += documentContainer
	})

	return template
}

function shareClassTemplate(shareClass) {
	const shareClassContainer = `<div class="cmp-fund-list-non-us__accordion__option">
  <div class="cmp-fund-list-non-us__accordion__option__toggle">
      ${shareClass.fundName}
  </div>
  <div class="cmp-fund-list-non-us__accordion__option__content">
      <div class="cmp-fund-list-non-us__accordion__option__content__disclaimer">
          ${shareClass.disclaimer}
      </div>
      <div class="cmp-fund-list-non-us__accordion__option__content__share-class-table  overflow-auto">
          <table>
          ${createShareClassTable(shareClass.table)}
          </table>

      </div>
  </div>
</div>`

	return shareClassContainer
}

function shareClassContainerTemplate(shareClass) {
	const shareClassContainer =
		`<div class="cmp-fund-list-non-us__accordion__option" id="fund-` +
		shareClass.fundId +
		`" data-fund-id="` +
		shareClass.fundId +
		`" data-investor-type-id="` +
		shareClass.investorType +
		`" data-show-kiids="` +
		shareClass.showKiids +
		`">
  <div class="cmp-fund-list-non-us__accordion__option__toggle">
      ${shareClass.fundName}
  </div>
  <div class="cmp-fund-list-non-us__accordion__option__content">
      <div class="cmp-fund-list-non-us__accordion__option__content__disclaimer">
          ${shareClass.disclaimer}
      </div>
      <div class="cmp-fund-list-non-us__accordion__option__content__share-class-table  overflow-auto">
          <table>
            <!-- ${createShareClassTableHeader(shareClass.table)} -->
          </table>                   
      </div>
  </div>
</div>`

	return shareClassContainer
}

function performanceContainerTemplate(performanceData, performancesContainer) {
	const newDiv = document.createElement('div')
	let performanceList = ''

	if (performanceData != null) {
		if (performanceData.PerformanceKoreaData != null) {
			if (performanceData.PerformanceKoreaData.FundPerformanceKoreaByISINList != null && performanceData.PerformanceKoreaData.FundPerformanceKoreaByISINList.length) {
				performanceData.PerformanceKoreaData.FundPerformanceKoreaByISINList.forEach((performanceGroup) => {
					let perfromanceTableRow = `
						<tr>
							<td>${performanceGroup.ClassName}</td>
							<td>${performanceGroup.ValuesInPeriod.OneMonth}</td>
							<td>${performanceGroup.ValuesInPeriod.ThreeMonths}</td>
							<td>${performanceGroup.ValuesInPeriod.SixMonths}</td>
							<td>${performanceGroup.ValuesInPeriod.OneYear}</td>
							<td>${performanceGroup.ValuesInPeriod.ThreeYears}</td>
							<td>${performanceGroup.ValuesInPeriod.FiveYears}</td>
							<td>${performanceGroup.ValuesInPeriod.YTD}</td>
							<td>${performanceGroup.ValuesInPeriod.SinceInception}</td>
						</tr>
						`
					performanceList += perfromanceTableRow
				})

				performancesContainer.innerHTML = ''
				let performanceAsOfDate = performanceData.PerformanceKoreaData.PerformanceKoreaAsOfDate ?? ''
				let performanceKoreaFootnote = performanceData.PerformanceKoreaData.PerformanceKoreaFootnote ?? ''

				newDiv.innerHTML =
					`<div class="row">
					<div class="col-12 col-sm-10 offset-sm-1">
						<div class="cmp-fund-tabs__panel__section">
							<div class="cmp-fund-tabs__panel__field">
								<div class="cmp-fund-tabs__panel__chart">
									<div class="title-table mt-2">${performanceData.FundPerformanceKoreaTitle}</div>
									<p class="text-small my-0">${performanceAsOfDate}</p>
									<p class="text-small text-right my-1">${performanceData.UnitText}</p>
									<div class="responsive-table-wrapper">
										<div class="responsive-table-wrapper">
											<div class="responsive-table-wrapper"><table class="table-striped">
												<thead>
													<tr>
														<th scope="col"></th>
														<th scope="col">${performanceData.OneMonthLabel}</th>
														<th scope="col">${performanceData.ThreeMonthsLabel}</th>
														<th scope="col">${performanceData.SixMonthsLabel}</th>
														<th scope="col">${performanceData.OneYearLabel}</th>
														<th scope="col">${performanceData.ThreeYearsLabel}</th>
														<th scope="col">${performanceData.FiveYearsLabel}</th>
														<th scope="col">${performanceData.YTDLabel}</th>
														<th scope="col">${performanceData.SinceInceptionLabel}</th>
													</tr>
												</thead>
												<tbody>
														${performanceList}
												</tbody>
											</table></div>
										</div>
									</div>
									<div class="footnotes-table">
										${performanceKoreaFootnote}
									</div>
								</div>
							</div>
		
						</div>
					</div>
				</div>`
			}
			else {
				newDiv.innerHTML = `<p>${performanceData.NoResultsFound}</p>`
			}
		}


	}

	performancesContainer.appendChild(newDiv)
}

async function getFundDocuments(fundId) {
	let language = document.documentElement.lang
	if (language.length === 0) {
		language = 'en'
	}

	let apiURL = ''
	if (window.location.hostname !== 'localhost') {
		apiURL = '/api/FundDocumentTab/GetFundDocuments'
	}

	const url =
		apiURL +
		'?fundId=' +
		fundId +
		'&lang=' +
		language

	const response = await window.fetch(url)
	const data = await response.json()
	return data.JsonContent
}

export default cmpFundListNonUs
